import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = `tags`;

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [state, setState] = useState(``);
  const [slug, setSlug] = useState(``);
  const [name, setName] = useState(``);
  const [showColumn, setShowColumn] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const handleChangeState = (value) => setState(value);
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.tags_store != undefined && appReducer.tags_store.error == false) ||
        (appReducer.tags_update != undefined && appReducer.tags_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.tags_store,
    appReducer.tags_update
  ])

  useEffect(() => {
    if (appReducer.tags_edit != undefined && id != undefined) {
      let row = appReducer.tags_edit.data;
      setName(row.name);
      setShowColumn(row.show_column)
      setSlug(row.slug);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
    }
  }, [appReducer.tags_edit]);


  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.Input required value={slug} label="عنوان در لینک" name="slug" type="text" />
    <Template.Input required value={showColumn} label="ستون نمایش در فوتر" name="show_column" type="text" />
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};